import c from "classnames";
import { ComponentProps } from "react";

import classes from "./Textarea.module.css";

type Props = Omit<ComponentProps<"textarea">, "className"> & {
  transparent?: boolean;
};

export const Textarea = ({ rows = 4, transparent, ...rest }: Props) => {
  return (
    <textarea
      className={c(classes.textarea, transparent && classes.transparent)}
      rows={rows}
      {...rest}
    />
  );
};
